// import React, { useState } from "react";

// export const DeletedVideoIcon = () => {
//     const [showTooltip, setShowTooltip] = useState(false);

//     return (
//         <div
//             style={{
//                 position: "relative",
//                 display: "inline-block",
//             }}
//         >
//             <button
//                 style={{
//                     backgroundColor: "transparent",
//                     border: "none",
//                     cursor: "pointer",
//                     padding: 0,
//                 }}
//                 onMouseEnter={() => setShowTooltip(true)}
//                 onMouseLeave={() => setShowTooltip(false)}
//             >
//                 <i
//                     className="material-icons"
//                     aria-hidden="true"
//                     style={{ color: "red", fontSize: 24 }}
//                 >
//                     report_problem
//                 </i>
//             </button>

//             {showTooltip && (
//                 <div
//                     style={{
//                         position: "absolute",
//                         bottom: "105%", // show above the icon
//                         left: "-50%",
//                         transform: "translateX(-50%)",
//                         backgroundColor: "rgba(0, 0, 0, 0.75)",
//                         color: "#fff",
//                         padding: "4px 8px",
//                         borderRadius: "4px",
//                         fontSize: "12px",
//                         whiteSpace: "nowrap",
//                         zIndex: 10000000,
//                     }}
//                 >
//                     Video has been deleted
//                     <div
//                         style={{
//                             position: "absolute",
//                             top: "100%",
//                             left: "67%",
//                             transform: "translateX(-50%)",
//                             width: 0,
//                             height: 0,
//                             borderLeft: "5px solid transparent",
//                             borderRight: "5px solid transparent",
//                             borderTop: "5px solid rgba(0, 0, 0, 0.75)",
//                         }}
//                     />
//                 </div>
//             )}
//         </div>
//     );
// };



import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export const DeletedVideoIcon = ({ onClick }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const { t } = useTranslation()

    return (
        <div
            style={{
                position: "relative",
                display: "inline-block",
            }}
        >
            <button
                onClick={onClick}
                style={{
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "pointer",
                    padding: 0,
                }}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
            >
                <i
                    className="material-icons"
                    aria-hidden="true"
                    style={{
                        color: "red",

                    }}
                >
                    report_problem
                </i>
            </button>

            {showTooltip && (
                <div
                    style={{
                        position: "absolute",
                        top: "50%",
                        right: "110%", // moves tooltip to the left
                        transform: "translateY(-50%)",
                        color: "rgba(0, 0, 0, 0.8)",
                        backgroundColor: "#fff",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        whiteSpace: "nowrap",
                        zIndex: 100,
                    }}
                >
                    {t("canvas.videoPlayError")}
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "100%",
                            transform: "translateY(-50%)",
                            width: 0,
                            height: 0,
                            borderTop: "5px solid transparent",
                            borderBottom: "5px solid transparent",
                            borderLeft: "5px solid rgba(0, 0, 0, 0.8)",
                        }}
                    />
                </div>
            )}
        </div>
    );
};
